import { useStaticQuery, graphql } from "gatsby";

export const useConfig = () => {
  const { config } = useStaticQuery(graphql`
    query ConfigQuery {
      config {
        faq {
          endpoint
          maxAnswers
        }
        contactUs {
          endpoint
          callUrl
        }
        jobApplication {
          endpoint
        }
        candidateTest {
          endpoint
        }
        seo {
          index
        }
      }
    }
  `);

  return config;
};
